import React, { useState } from 'react';
import { Modal } from '../../../Smart/Modal/Modal';
import { TextField } from '@mui/material';
import { Button } from '../../../Form/Button/Button';
import { buttonColors } from '../../../Pickers/InputTheme';
import { i18n } from '../../../../Utils/i18n/i18n';
import './RejectUploadModal.scss';

/**
 * Modal for rejecting user uploaded documents
 * @param {boolean} open - Whether modal is open
 * @param {Function} onClose - Close modal callback
 * @param {Object} userSignDoc - UserSignDoc being rejected
 * @param {Function} onReject - Reject callback with (userSignDocId, rejectionReason, deleteFiles)
 */
export const RejectUploadModal = ({ open, onClose, userSignDoc, onReject }) => {
    const [rejectionReason, setRejectionReason] = useState('');
    const [deleteFiles, setDeleteFiles] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleReject = async () => {
        if (!userSignDoc) return;

        setIsSubmitting(true);
        try {
            await onReject(
                userSignDoc.id,
                rejectionReason.trim() || undefined,
                deleteFiles
            );
            // Reset state after successful rejection
            setRejectionReason('');
            setDeleteFiles(false);
        } catch (error) {
            console.error('Error in RejectUploadModal:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleClose = () => {
        if (!isSubmitting) {
            setRejectionReason('');
            setDeleteFiles(false);
            onClose();
        }
    };

    return (
        <Modal open={open} onClose={handleClose}>
            <div className="rejectUploadModal">
                <h2 className="rejectUploadModal__title">
                    {i18n.translate('pendingApprovals.rejectDialog.title')}
                </h2>

                <div className="rejectUploadModal__content">
                    <TextField
                        fullWidth
                        multiline
                        rows={4}
                        label={i18n.translate('pendingApprovals.rejectDialog.reasonLabel')}
                        placeholder={i18n.translate('pendingApprovals.rejectDialog.reasonPlaceholder')}
                        value={rejectionReason}
                        onChange={(e) => setRejectionReason(e.target.value)}
                        disabled={isSubmitting}
                        className="rejectUploadModal__textField"
                    />
                </div>

                <div className="rejectUploadModal__actions">
                    <Button
                        onClick={handleClose}
                        color={buttonColors.YELLOW}
                        disabled={isSubmitting}
                        text={i18n.translate('pendingApprovals.rejectDialog.cancel')}
                    >
                    </Button>
                    <Button
                        onClick={handleReject}
                        color={buttonColors.GREY}
                        disabled={isSubmitting}
                        text={i18n.translate('pendingApprovals.rejectDialog.confirm')}
                    >
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default RejectUploadModal;
